import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const { language, toggleLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled ? 'bg-obsidian/80 backdrop-blur-md border-white/5' : 'bg-transparent border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex flex-col">
          <h1 className="text-white font-medium tracking-tight text-lg">
            Giancarlo Guacci
          </h1>
          <span className="text-xs font-mono text-mutedGray tracking-wider">
            SOFTWARE DEVELOPER
          </span>
        </div>
        
        <div className="flex items-center gap-8">
            <nav className="hidden md:block">
            <ul className="flex items-center gap-8">
                {['capabilities', 'process', 'contact'].map((item) => (
                <li key={item}>
                    <a 
                    href={`#${item}`} 
                    onClick={(e) => handleNavClick(e, item === 'contact' ? 'contact' : item)}
                    className="text-sm font-mono text-mutedGray hover:text-white transition-colors cursor-pointer capitalize"
                    >
                    {t.nav[item as keyof typeof t.nav]}
                    </a>
                </li>
                ))}
            </ul>
            </nav>

            {/* Language Toggle */}
            <button 
                onClick={toggleLanguage}
                className="font-mono text-sm tracking-wider flex items-center gap-2 px-3 py-1 rounded hover:bg-white/5 transition-colors group"
                aria-label="Toggle Language"
            >
                <span className={`transition-colors duration-300 ${language === 'en' ? 'text-white font-medium' : 'text-zinc-600 group-hover:text-zinc-400'}`}>EN</span>
                <span className="text-zinc-700">|</span>
                <span className={`transition-colors duration-300 ${language === 'it' ? 'text-white font-medium' : 'text-zinc-600 group-hover:text-zinc-400'}`}>IT</span>
            </button>
        </div>
      </div>
    </header>
  );
};